import React from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import {ReactComponent as GeneralIcon} from '../../images/icon-general.svg';
import {ReactComponent as StylesIcon} from '../../images/icon-styles.svg';
import {ReactComponent as ContentIcon} from '../../images/icon-content.svg';

import { Tabs,TabContent } from '.';

const makeIconLabel = (IconName) => (
  <SvgIcon>
    <IconName />
  </SvgIcon>
)

// Tabs for interactive editor panel
export const EditorTabs = (props) => {
    
    return (
      <Tabs>
        <TabContent title="General" label={makeIconLabel(GeneralIcon)}>

          {props.general}

        </TabContent>

        <TabContent title="Styles" label={makeIconLabel(StylesIcon)}>

          {props.styles}
      
        </TabContent>

        <TabContent title="Content" label={makeIconLabel(ContentIcon)}>
          
          {props.content}

        </TabContent>

      </Tabs>
    
    );
  }

